const LayoutDefault = () =>
  import(/* webpackChunkName: "customer-service" */ '@/layouts/LayoutDefault.vue');
const LayoutData = () =>
  import(/* webpackChunkName: "customer-service" */ '@/layouts/LayoutData.vue');

const WhatsappChat = () =>
  import(
    /* webpackChunkName: "customer-service" */ '@/views/pusat/customer-service/whatsapp-chat.vue'
  );
const BroadcastDevice = () =>
  import(
    /* webpackChunkName: "customer-service" */ '@/views/pusat/customer-service/broadcast/broadcast-device.vue'
  );
const BroadcastTemplate = () =>
  import(
    /* webpackChunkName: "customer-service" */ '@/views/pusat/customer-service/broadcast/broadcast-template.vue'
  );
const TambahBroadcast = () =>
  import(
    /* webpackChunkName: "customer-service" */ '@/views/pusat/customer-service/broadcast/tambah-broadcast.vue'
  );
const ResponsePattern = () =>
  import(
    /* webpackChunkName: "customer-service" */ '@/views/pusat/customer-service/response-pattern.vue'
  );
const UcapanUlangTahun = () =>
  import(
    /* webpackChunkName: "customer-service" */ '@/views/pusat/customer-service/ucapan-ulang-tahun.vue'
  );

let root = '/customer-service';

export default [
  {
    path: root + '/',
    component: WhatsappChat,
    meta: {
      auth: true,
      title: 'Whatsapp Chat',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/broadcast/',
    component: LayoutData,
    children: [
      {
        path: 'device',
        component: BroadcastDevice,
        meta: {
          auth: true,
          title: 'Broadcast Device',
          layout: LayoutDefault,
          breadcrumb: 'Broadcast',
        },
      },
      {
        path: 'template',
        component: BroadcastTemplate,
        meta: {
          auth: true,
          title: 'Broadcast Template',
          layout: LayoutDefault,
          breadcrumb: 'Broadcast',
        },
      },
      {
        path: 'tambah',
        component: TambahBroadcast,
        meta: {
          auth: true,
          title: 'Tambah Broadcast',
          layout: LayoutDefault,
          breadcrumb: 'Broadcast',
        },
      },
    ]
  },
  {
    path: root + '/response-patterns',
    component: ResponsePattern,
    meta: {
      auth: true,
      title: 'Pola Respon',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/ucapan-ulang-tahun',
    component: UcapanUlangTahun,
    meta: {
      auth: true,
      title: 'Pola Respon',
      layout: LayoutDefault,
    },
  },
];
